// How a basis item's test is addressed, wherever it is rendered.
//
// It lives here, away from any router, so the operating-effectiveness surfaces and the testing
// surfaces can agree on an id without either importing the other's pages.

const slug = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

/**
 * Basis item ids are only unique within one assessment, and one control can carry an assessment per
 * application, so the scenario, control and scope all have to be in the key.
 */
export const testIdFor = (scenarioId: string, control: string, scope: string, itemId: string): string =>
  [scenarioId, control, scope, itemId].map(slug).join("-");
